const featureToggles = {
  // Allow-list of user IDs who see gated features.
  featureFlagOverrideUserIds: [2, 341236],
  // PAYG credit purchase on pricing page (TP-187). Off in production until launch.
  paygCreditsPricingPage: false,
};

export default featureToggles;
